class EventBus {
  // TODO: add support for array of events. eg: .on(['click', 'hover'])
  on(event: any, callback: (arg0: any) => any) {
    document.addEventListener(event, (e) => callback(e.detail));
  }

  dispatch(event: string, data: any) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  }

  remove(event: any, callback: (this: Document, ev: any) => any) {
    document.removeEventListener(event, callback);
  }
}

const eventBus = new EventBus();

export default eventBus;
